var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    staticClass: "activate-2fa",
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.$t.__(
        "popups.Activate2FAProvider.activate_dual_authentication"
      )
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: function($event) {
        return _vm.$emit("close")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__default" },
              [
                _c("ProviderLabel2FA", { attrs: { provider: _vm.provider } }),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "typographies-paragraph-medium-regular" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Vous êtes sur le point d’activer la double authentification avec Google Authenticator."
                          )
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("CompassAlert", {
                  attrs: {
                    type: "error",
                    description: _vm.$t.__(
                      "popups.Activate2FAProvider.log_in_again_to_begin_setup"
                    ),
                    showIcon: "",
                    action: null,
                    showClose: false
                  }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "m-0 gray-60" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$l10n.__("Besoin d'aide ?")) +
                      "\n                "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://help.sellsy.com/fr/articles/6178777-comment-fonctionne-la-double-authentification",
                        target: "_blank"
                      }
                    },
                    [
                      _c("span", { staticClass: "bold" }, [
                        _vm._v(
                          _vm._s(_vm.$l10n.__("Consulter notre page dédiée."))
                        )
                      ])
                    ]
                  )
                ])
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary",
                    size: "medium"
                  },
                  on: { click: _vm.close }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "ml-3",
                  attrs: {
                    label: _vm.$t.__("common.actions.continue"),
                    type: "primary",
                    loading: _vm.loading
                  },
                  on: {
                    click: function($event) {
                      return _vm.save()
                    }
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }